import './observodon-stationery.css';

import Logo, { eLogo } from '../Logo/Logo';
import React, { CSSProperties } from 'react';

import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid2';
import IconButton from '@mui/material/IconButton';
import MailIcon from '@mui/icons-material/Mail';
import ObservodonTheme from '../ObservodonTheme/ObservodonTheme';
import { SITE_PRIMARY_COLOR } from '../../constants';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';

export interface ObservodonStationeryProps {
  /** Page content to render within the frame. */
  children: (JSX.Element | undefined) | (JSX.Element | undefined)[];
  /** Link to use for the logo, default "/" home page. */
  link?: string;
  /** Optional menu to render in the top-left. */
  menu?: JSX.Element;
  /** Optional title to set for the page. */
  title?: string | JSX.Element;
  /** Optional descriptive text. */
  description?: string | JSX.Element;
  /** Optional CSS class for content, default observodon-stationery-content. */
  contentClassName?: string;
  /** Optional switch to keep left align. */
  textAlign?: 'left' | 'center' | 'unset';
  /** Optional styles to apply to the container, e.g. maxWidth. */
  style?: CSSProperties;
}

/** Link for Contact Us button. */
const CONTACT_US = 'mailto:info@observodon.cloud';

const ObservodonStationery = (props: ObservodonStationeryProps) => {
  const { link, menu, title, description, contentClassName } = props;
  
  const { t } = useTranslation('common');
  
  return (
    <ObservodonTheme>
      <div className="observodon-stationery-root">
        <div className="observodon-stationery-background"></div>
        <header>
          <Grid
            container
            direction="row"
            alignItems="center"
            className="observodon-stationery-header"
            wrap="nowrap"
          >
            {menu && <Grid>{menu}</Grid>}
            <Grid style={{ flexGrow: 1 }}>
              <Grid
                container
                justifyContent="space-between"
                alignItems="center"
                wrap="nowrap"
              >
                <Grid>
                  <a href={link || '/'} style={{ textDecoration: 'none' }}>
                    <Logo
                      height={60}
                      logo={eLogo.mono}
                      className="header-logo"
                    />
                  </a>
                </Grid>
                <Grid>
                  <Button
                    color="secondary"
                    variant="contained"
                    className="screen-full"
                    href={CONTACT_US}
                  >
                    <Typography variant="body1" color={SITE_PRIMARY_COLOR}>
                      {t('contact')}
                    </Typography>
                  </Button>
                  <IconButton
                    color="primary"
                    className="screen-small"
                    href={CONTACT_US}
                  >
                    <Tooltip title={t('contact')}>
                      <MailIcon />
                    </Tooltip>
                  </IconButton>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </header>

        <div className="observodon-stationery-scroll">
          <div
            className={contentClassName || 'observodon-stationery-content'}
            style={{ ...props.style, textAlign: props.textAlign || 'center' }}
          >
            {title && (
              <Typography
                variant="h4"
                color="primary"
                className="observodon-stationery-title"
              >
                {title}
              </Typography>
            )}
            {description && (
              <Typography className="observodon-stationery-description">
                {description}
              </Typography>
            )}
            {props.children}
          </div>
        </div>
      </div>
    </ObservodonTheme>
  );
};

export default ObservodonStationery;
